import axios from 'axios';

const a = axios.create({
  baseURL: `${process.env.GATSBY_API_URL}`,
});

export const post = (url, body) => a.post(url, body);
